import React, { useEffect, useState } from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import { motion } from "framer-motion";

const AnimatedButton = ({ children, ...rest }) => (
  <motion.div whileTap={{ scale: 0.9 }}>
    <Button variant="contained" {...rest}>
      {children}
    </Button>
  </motion.div>
);

const NumberButton = ({ num, onClick }) => (
  <AnimatedButton
    color="primary"
    onClick={onClick}
    sx={{ width: 80, height: 60, borderRadius: "30px", fontSize: "20px" }}
  >
    {num}
  </AnimatedButton>
);

const PinDisplay = ({ pin, length = 6 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 1,
        mt: 4,
        mb: 6,
      }}
    >
      {[...Array(length)].map((_, index) => {
        const isFilled = index < pin.length;
        return (
          <motion.div
            key={index}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            style={{
              width: 30,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 24,
              fontWeight: "bold",
              color: isFilled ? "#ff69b4" : "#bbb",
              borderBottom: "3px solid #ff69b4",
            }}
          >
            {isFilled ? pin[index] : "*"}
          </motion.div>
        );
      })}
    </Box>
  );
};

const Login = ({ onLogin, title = "Enter Your Secret Code 💕" }) => {
  const validPassword = "011222";

  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleButtonClick = (num) => {
    if (pin.length < validPassword.length) {
      setPin(pin + num);
    }
  };

  const handleBackspace = () => {
    setPin(pin.slice(0, -1));
  };

  // Check if the entered pin is correct
  useEffect(() => {
    if (pin.length === validPassword.length) {
      handleSubmit();
    }
  }, [pin]);

  const handleSubmit = () => {
    if (pin === validPassword) {
      // Success
      setSuccess(true);
      setTimeout(() => {
        onLogin();
      }, 1500);
    } else {
      // Error
      setError(true);
      setTimeout(() => {
        setError(false);
        setPin("");
      }, 2000);
    }
  };

  return (
    <Container sx={{ textAlign: "center" }}>
      <Typography variant="h5">
        {title}
      </Typography>

      <PinDisplay pin={pin} length={validPassword.length} />

      {/* Animated Number Pad */}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 0fr)", gap: 2, justifyContent: "center" }}>
        {[...Array(9)].map((_, index) => (
          <NumberButton
            key={index + 1}
            num={index + 1}
            onClick={() => handleButtonClick((index + 1).toString())}
          />
        ))}

        <Box /> {/* Empty Box for alignment */}
        <NumberButton num={0} onClick={() => handleButtonClick("0")} />
        <NumberButton num="⌫" onClick={() => handleBackspace()} />
      </Box>

      {/* Success */}
      {success && (
        <Typography color="success" sx={{ mt: 4, fontWeight: "bold" }}>
          ✅ เก่งมากก ผ่านครับบบ 🎉
        </Typography>
      )}

      {/* Error */}
      {error && (
        <Typography color="error" sx={{ mt: 4 }}>
          ❌ Wrong Code! Try again.
        </Typography>
      )}
    </Container>
  );
};

export default Login;
